module.exports = __webpack_public_path__ + "img/logo_bp-min.1a6bb063.jpg";